import { redirect } from '../helpers/url';
import Recaptcha from '../services/recaptcha';
const responseHandle = (response) => {
    if (response.success === true) {
        const activationSent = typeof response.activation_mail !== 'undefined' && response.activation_mail === true
            ? '/activationmail/1'
            : '';
        redirect('/newsletter/added' + activationSent);
    }
    if (response.errors) {
        // Wyczyść istniejące komunikaty błędów
        const form = document.querySelector('.newsletter-page #newsletter-form');
        if (form !== null) {
            form.querySelectorAll('.status').forEach((el) => {
                el.textContent = '';
            });
        }
        // Ustaw nowe komunikaty błędów w elementach .status sąsiadujących z polem z błędem
        for (const [key, value] of Object.entries(response.errors)) {
            const input = document.querySelector(`input[name="${key}"]`);
            if (input) {
                input.classList.add('error');
                let status = null;
                if (input.type === 'radio') {
                    status = input.parentElement?.parentElement?.querySelector('.status') ?? null;
                }
                else {
                    status = input.parentElement?.querySelector('.status') ?? null;
                }
                if (status === null) {
                    continue;
                }
                status.textContent = '' + value;
            }
        }
    }
};
const formSubmit = () => {
    const form = document.querySelector('.newsletter-page #newsletter-form');
    if (!form) {
        return;
    }
    const csrf = form.querySelector('input[name="P[csrf]"]');
    const email = form.querySelector('input[name="P[email]"]');
    if (!email || !csrf) {
        return;
    }
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        const recaptcha = new Recaptcha();
        recaptcha
            .verifyToken()
            .then((result) => {
            if (!result) {
                return;
            }
            if (form.dataset.processing == '1') {
                return;
            }
            form.dataset.processing = '1';
            const formData = new FormData(form);
            const data = new URLSearchParams();
            for (const pair of formData) {
                const [fieldName, fieldValue] = pair;
                data.append(fieldName, typeof fieldValue === 'string' ? fieldValue : '');
            }
            fetch('/newsletter/insert', {
                method: 'POST',
                cache: 'no-cache',
                body: data,
            })
                .then((response) => {
                if (response.ok === false) {
                    throw new Error('Unknown failure');
                }
                return response.json();
            })
                .then((result) => {
                responseHandle(result);
            })
                .catch((err) => {
                console.error(err);
            })
                .finally(() => {
                form.dataset.processing = '0';
            });
        })
            .catch((err) => {
            console.error('Recaptcha error', err);
        });
    });
};
export default () => {
    formSubmit();
};
